import { EmployeeCenterDetailsType } from 'src/components/Employees/types';
import type { ValidationError, APIError } from './types';

export const getAPIFormErrors = (errors: APIError[]): ValidationError => {
    const errorsObject: ValidationError = {};
    if (Array.isArray(errors) && errors.length) {
        errors.forEach((obj: APIError) => {
            errorsObject[obj.field] = obj.message;
        });
    }
    return errorsObject;
};

export const updateEmployeeCenters = (
    employeeCenters: EmployeeCenterDetailsType[]
): EmployeeCenterDetailsType[] | null => {
    if (!employeeCenters) return null;
    return employeeCenters.map((center: any) => {
        if (center.civilLawNatureContract) {
            return {
                ...center,
                rolesCLNC: center.roles,
                dateOfStartingCLNC: center.dateOfStarting,
                roles: undefined,
                dateOfStarting: undefined
            };
        }
        return center;
    });
};

/**
 * Remove service data that needed for UI only before it'll be send to backend
 * @param { any } payload
 */
export const getRidOfServiceKeys = (payload: any): void => {
    if (typeof payload === 'object') {
        // __submitAttempt is used for employees form to show/hide checkboxes custom validation
        const serviceKeys = ['__submitAttempt'];

        serviceKeys.forEach((key) => {
            if (payload.hasOwnProperty(key)) {
                delete payload[key];
            }
        });
    }
};
